'use strict';

(function () {
  'use strict';

  angular.module('msUtility').filter('minutes', ['$translate', function ($translate) {

    /**
     * This takes a number of minutes and converts it to a representive string.
     *
     * Examples:
     * 0 -> '0min'
     * 30 -> '30min'
     * 60 -> '1h '
     * 90 -> '1h 30min'
     */

    return function (minutes, type) {
      var minutesInHour = minutes % 60;
      var hours = Math.floor(minutes / 60);
      var hourDesk = hours > 1 ? $translate.instant('common.time.hours') : $translate.instant('common.time.hour');
      var minDesk = $translate.instant('common.time.minutes');

      if (type !== 'full') {
        hourDesk = hourDesk.slice(0, 1);
        minDesk = minDesk.slice(0, 3);
      }

      if (minutes === 0) {
        return '0 ' + minDesk;
      }

      if (!minutes || !_.isNumber(minutes)) {
        return '';
      }

      // Only display non-zero
      return (hours === 0 ? '' : hours + ' ' + hourDesk + ' ') + (minutesInHour === 0 ? '' : minutesInHour + ' ' + minDesk);
    };
  }]);
})();